<template>
    <svg ref="compass" class="compass compass--animate" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 33" >
        <circle class="compass__inner" fill="none" stroke="#999" stroke-width="3" stroke-miterlimit="10" cx="17" cy="17" r="3.5"/>
        <path class="compass__needle" fill="#999" d="M14.5,14.5L8.2,25.8l11.3-6.3l6.3-11.3L14.5,14.5z M18.8,18.8c-1,1-2.6,1-3.5,0c-1-1-1-2.6,0-3.5c0.5-0.5,1.1-0.7,1.8-0.7c0.6,0,1.3,0.2,1.8,0.7C19.7,16.2,19.7,17.8,18.8,18.8z"/>
        <circle class="compass__outer" fill="none" stroke="#999" stroke-width="3" stroke-miterlimit="10" cx="17" cy="17" r="15.5"/>
    </svg>
</template>

<script>
    export default {
        name: "LocationCompass"
    }
</script>

<style scoped>
    .compass {
        width: 100px;
        height: 100px;
        opacity: 0;
        transition: opacity 0.3s linear;
        fill: #666;
    }

    .compass--animate {
        opacity: 1;
    }

    .compass--animate .compass__inner {
        stroke-dasharray: 23;
        stroke-dashoffset: 23;
        -webkit-animation: compass-inner-dash 2s linear infinite;
        animation: compass-inner-dash 2s linear infinite;
    }

    @-webkit-keyframes compass-inner-dash {
        25%, 75%, 90% {
            stroke-dashoffset: 46;
            opacity: 1;
        }
        95%, 100% {
            stroke-dashoffset: 46;
            opacity: 0;
        }
    }

    @keyframes compass-inner-dash {
        25%, 75%, 90% {
            stroke-dashoffset: 46;
            opacity: 1;
        }
        95%, 100% {
            stroke-dashoffset: 46;
            opacity: 0;
        }
    }

    .compass--animate .compass__needle {
        -webkit-transform: scale(0);
        transform: scale(0);
        -webkit-transform-origin: 17px 17px;
        transform-origin: 17px 17px;
        -webkit-animation: compass-needle 2s ease-in-out infinite;
        animation: compass-needle 2s ease-in-out infinite;
    }

    @-webkit-keyframes compass-needle {
        25% {
            -webkit-transform: rotate(0deg) scale(0);
        }
        50% {
            -webkit-transform: rotate(0deg) scale(1);
        }
        75%, 90% {
            -webkit-transform: rotate(-360deg) scale(1);
            opacity: 1;
        }
        95%, 100% {
            -webkit-transform: rotate(-360deg) scale(1);
            opacity: 0;
        }
    }

    @keyframes compass-needle {
        25% {
            transform: rotate(0deg) scale(0);
        }
        50% {
            transform: rotate(0deg) scale(1);
        }
        75%, 90% {
            transform: rotate(-360deg) scale(1);
            opacity: 1;
        }
        95%, 100% {
            transform: rotate(-360deg) scale(1);
            opacity: 0;
        }
    }

    .compass--animate .compass__outer {
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
        -webkit-transform-origin: 17px 17px;
        transform-origin: 17px 17px;
        stroke-dasharray: 100;
        stroke-dashoffset: 100;
        -webkit-animation: compass-outer-dash 2s ease-in-out infinite;
        animation: compass-outer-dash 2s ease-in-out infinite;
    }

    @-webkit-keyframes compass-outer-dash {
        50% {
            stroke-dashoffset: 100;
            opacity: 1;
        }
        75%, 90% {
            stroke-dashoffset: 200;
            opacity: 1;
        }
        95%, 100% {
            stroke-dashoffset: 200;
            opacity: 0;
        }
    }

    @keyframes compass-outer-dash {
        50% {
            stroke-dashoffset: 100;
            opacity: 1;
        }
        75%, 90% {
            stroke-dashoffset: 200;
            opacity: 1;
        }
        95%, 100% {
            stroke-dashoffset: 200;
            opacity: 0;
        }
    }
</style>